import React, { useMemo } from "react";
import { colorMap, colorModeMap, gradientMap } from "./helpers";
import { mix, opacify, toHex } from "color2k";
import { cssColor } from "shared/src/utils/cssUtils";

function isValidColor(color) {
  return typeof color === "string" && /^#|var|rgba?|hsla?/i.test(color)
}

function processColor(colorType, color) {
  if (!color) return color;
  const [isLight, isDark] = [colorType === "light", colorType === "dark"];
  const lightColor = "#fff";
  const darkColor = "rgb(3,3,3)";

  // Create overlay with opacity using `color-mix()` css function
  if (/var\(/.test(color)) {
    if (isLight) return `color-mix(in srgb, ${color}, ${lightColor})`
    if (isDark) return `color-mix(in srgb, ${color}, ${darkColor})`
    return color;
  }
  // Use javacsript to replicate mixing overlay with opacity with the color.
  if (isLight) return toHex(mix(color, opacify(lightColor, .4), .5));
  if (isDark) return toHex(mix(color, opacify(darkColor, .4), .5));
  return color;
} 

export const styleConstructor = ({primaryColor, secondaryColor, gradient, colorType, colorMode, gradientSharpness, width, height, style, fallbackPrimaryColor, fallbackSecondaryColor }) => {
    const styles = useMemo(() => {
        let _styles = {
          ["--cui-background-primary-color"]: processColor(colorType, cssColor(fallbackPrimaryColor)),
          ["--cui-background-secondary-color"]: processColor(colorType, cssColor(fallbackSecondaryColor)),
        };

        if (primaryColor && isValidColor(primaryColor)) {
          _styles["--cui-background-primary-color"] = processColor(colorType, primaryColor);
        }
        if (primaryColor && isValidColor(secondaryColor)) {
          _styles["--cui-background-secondary-color"] = processColor(colorType, secondaryColor);
        }
        const canBeGradient = colorMode === "both";

        let gradientStyling = `linear-gradient(${gradientMap[gradient]}, ${
          colorModeMap(gradientSharpness)
        })`;
    
        if (canBeGradient) {
          _styles["backgroundImage"] = gradientStyling;
        } else {
          _styles[
            "backgroundColor"
          ] = processColor(colorType, `var(--cui-background-${colorMode}-color)`);
        }
    
        if (!!width) _styles["width"] = width;
        if (!!height) _styles["height"] = height;
    
        return { ..._styles, ...style };
      }, [primaryColor, secondaryColor, gradient, colorMode, colorType, gradientSharpness, width, height]);
    return styles
};